import React from 'react'

const InterviewTips = () => {
  return (
    <div>
    <h1>how to crack the neoG interview</h1>
    <hr />

    <ol>
        <li>As you might know by now that to get into levelOne you need to clear interviews. You will get interview call only if,
            <ul>
                <li>you have completed levelZero exercises and assignments and has a mark15 role in the admission platform.</li>
                <li>you have filled out the admission form properly.</li>
            </ul>
        </li>
        <li>why interview?You will get interview call only if,
            <ul>
                <li>The vision for levelOne is to have a peer group of hard-working and smart people. These students will then go and make a mark in their career and create a network amongst themselves which will help in growing everyone.</li>
                <li>you have filled out the admission form properly.</li>
            </ul>
        </li>
        <li>are you going to reject me?
            <ul>
                <li>Mostly no. Understand that we are interviewing with an intent to accept and not with the intent to reject. We won't take pride in leaving someone who has worked hard on levelZero behind or knows all the concepts taught on levelZero.</li>
            </ul>
        </li>
        <li>okay, what are the grounds for immediate rejection then?
            <ul>
                <li>You have cheated. You don't understand the code, you didn't do the exercise as it was intended. You just copy-pasted code from the live video without trying to do it yourself. You can ask how would we test this, it's simple, we'll explain in the next section.</li>
                <li>You can't read instructions. We don't want kids, we want responsible adults. If during levelZero your first reaction has been to tag OG Admins on Discord for every doubt believe us we know. We have been running a list of repeat offenders. And I (Tanay) would strongly suggest you not to apply for levelOne.</li>
                <li>You have an attitude problem. We want positive people in the peer group. If you are not helping folks, if you're always lamenting about this or that, if you are always criticizing every move, trust us, we are noticing that kind of behavior too. It's good that you know something about web development, use it to help people, not to show off by putting snarky comments everywhere and bringing the morale down.</li>
                
            </ul>
        </li>
    </ol>
</div>
  )
}

export default InterviewTips